export const availableLanguages = [
    "af",
    "ain",
    "sq",
    "ar",
    "hy",
    "eu",
    "bn",
    "bs",
    "br",
    "bg",
    "my",
    "yue",
    "ca",
    "zh",
    "hr",
    "cs",
    "da",
    "nl",
    "en",
    "eo",
    "et",
    "fo",
    "fi",
    "nl_BE",
    "fr",
    "ka",
    "de",
    "el",
    "ht",
    "haw",
    "he",
    "hi",
    "hu",
    "is",
    "id",
    "ga",
    "it",
    "ja",
    "jv",
    "kn",
    "km",
    "ko",
    "ku",
    "la",
    "lv",
    "lt",
    "jbo",
    "mk",
    "ms",
    "mt",
    "mr",
    "mn",
    "nv",
    "no",
    "os",
    "ps",
    "fa",
    "pl",
    "ro",
    "ru",
    "sa",
    "sr",
    "sk",
    "sl",
    "es",
    "sw",
    "sv",
    "tl",
    "ta",
    "te",
    "th",
    "bo",
    "to",
    "tr",
    "tk",
    "udm",
    "uk",
    "ur",
    "ug",
    "uz",
    "vi",
    "cy",
    "yi",
    "zu"
];

export const languages = [
    {
        value: "zh",
        text: "languages.Chinese",
        nativeText: "中文"
    },
    {
        value: "en",
        text: "languages.English",
        nativeText: "English"
    },
    {
        value: "fr",
        text: "languages.French",
        nativeText: "Français"
    },
    {
        value: "de",
        text: "languages.German",
        nativeText: "Deutsch"
    },
    {
        value: "ja",
        text: "languages.Japanese",
        nativeText: "日本語"
    },
    {
        value: "es",
        text: "languages.Spanish",
        nativeText: "Español"
    }
];

export const languageMap = languages.reduce((soFar, l) => {
    soFar[l.value] = l;
    return soFar;
}, {});



// WEBPACK FOOTER //
// ./src/constants/languages.constants.js